import _objectSpread from "/www/wwwroot/shishai_admin_fe/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  computed: _objectSpread({}, mapGetters(['show_logo'])),
  data: function data() {
    return {
      title: '系统管理后台',
      logo: 'https://uniapp.wangshouxin.cn/hand-logo.png',
      logo1: require('../../../assets/logow.png') // require('../../../assets/long-log.png')

    };
  }
};